export default __webpack_public_path__ + "static/media/3.d6536f9d.svg";